import BaseApi from '../base/base'
import ReviewForm from '../../forms/review'
import Review from '../../models/review'

export default class ReviewApi extends BaseApi {
  constructor() {
    super()
    this.path = '/reviews'
  }

  async create(reviewForm: ReviewForm) {
    const response = await this.postFormData(reviewForm.toFormData())
    return new Review(response.data)
  }

  async update(reviewId: number, reviewForm: ReviewForm) {
    this.path = `/reviews/${reviewId}`
    const response = await this.putFormData(reviewForm.toFormData())
    return response
  }

  async show(course_id = '0') {
    this.path = `/reviews/`
    const response = await this.getRequest({course_id: course_id})
    return new Review(response.data)
  }

  async delete(id = '0') {
    this.path = `/reviews/${id}`
    await this.deleteRequest()
    return
  }
}
